import { render, staticRenderFns } from "./SignDeclaration.vue?vue&type=template&id=3a1bdbac&scoped=true&"
import script from "./SignDeclaration.vue?vue&type=script&lang=js&"
export * from "./SignDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./SignDeclaration.vue?vue&type=style&index=0&id=3a1bdbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1bdbac",
  null
  
)

export default component.exports